import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import AuthForm from "./components/AuthForm";
import { app } from "./firebase";
import Main from "./pages/Main";
import Navbar from "./components/Navbar";
import { Router ,Routes,Route,BrowserRouter } from "react-router";
import CategoryPage from "./pages/CategoryPage";
import ContentView from "./pages/ContentView";
import HomePage from "./pages/HomePage";
import Footer from "./components/Footer";
import Privacy from "./pages/Privacy";
import Rules from "./pages/Rules";
const auth = getAuth(app);

const App = () => {
  const [user, setUser] = useState(null);

  // Listen to auth state changes (persistent session)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (err) {
      console.error("Error logging out:", err);
    }
  };

  return (
    <div>
    
        <div style={{ textAlign: "center" }}>
          
          <BrowserRouter>
          
          
            <Routes>
              <Route path="/" element={<HomePage />}/>
              <Route path="/category/:id" element={<CategoryPage />} />
              <Route path="/exercise/:category/:id" element={<ContentView />}/>
              <Route path="/privacy" element={<Privacy></Privacy>}/>
              <Route path="/rules" element={<Rules/>}/>
            </Routes>
            <Footer/>
          </BrowserRouter>
        </div>
      
    </div>
  );
};

export default App;
